(function () {
  const sections = document.querySelectorAll('[data-food-cta-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('ffcta-is-visible'), index * 80);
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -50px 0px' }
    );

    root.querySelectorAll('.ffcta-reveal').forEach((el) => revealObserver.observe(el));
  });
})();
